import PropTypes from "prop-types";
import React from "react";

const compact = (n) => {
  if (n == null) return null;
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `${Math.round(n / 1000)}k`;
  return `${n}`;
};

const STATS = [
  ["Spotify followers", "spotifyFollowers"],
  ["Instagram", "instagramFollowers"],
  ["TikTok", "tiktokFollowers"],
  ["Facebook", "facebookFollowers"],
];

const AudienceCard = ({ audience }) => {
  if (!audience) {
    return (
      <div className="d2-card">
        <div className="d2-card-header"><h2 className="d2-card-title">Audience</h2></div>
        <div className="hd-empty"><div className="hd-empty-title">No audience data</div>
          <div className="hd-empty-sub">Add a headliner with connected socials to see reach.</div></div>
      </div>
    );
  }
  const present = STATS.filter(([, key]) => audience[key] != null);
  return (
    <div className="d2-card">
      <div className="d2-card-header"><h2 className="d2-card-title">Audience</h2></div>
      <p className="hd-audience-sub">{audience.artistName}</p>
      <div className="hd-audience-grid">
        {present.map(([label, key]) => (
          <div key={key} className="hd-audience-stat">
            <div className="hd-audience-label">{label}</div>
            <div className="hd-audience-value">{compact(audience[key])}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

AudienceCard.propTypes = { audience: PropTypes.object };
export default AudienceCard;
